import type { FunctionComponent } from 'react';

import type { ApplicationEntity } from './types';

import styles from './Application.less';

type ApplicationProps = Pick<ApplicationEntity, 'text'>;

export const Application: FunctionComponent<ApplicationProps> = ({ text }) => {
  return <span className={styles.fontWeightBold}>{text}</span>;
};
